import { imageSizeMap } from "../../content/configuration";
import { Configuration, Section } from "../../resources/modelTypes";
import { getPhotoByPk, RootState } from "../../resources/reduxTypes";
import { css } from "@emotion/react";
import React, { memo } from "react";
import { connect } from "react-redux";

const styles = {
  container: css`
    text-align: center;
  `,
  imageStyles: css`
    box-sizing: border-box;
    display: block;
    height: auto;
    width: 100%;
  `,
  registryImageStyles: css`
    object-fit: contain;
    height: 100%;
    width: 100%;
  `,
};

export type DisplayPhotoProps = {
  isRegistryPhoto?: boolean;
  configuration: Configuration;
  section: Section;
  defaultImage?: string;
};

export type DisplayPhotoPropsWithRedux = {
  original: string;
} & DisplayPhotoProps;

const DisplayPhoto = ({
  configuration,
  isRegistryPhoto = false,
  original,
  defaultImage,
}: DisplayPhotoPropsWithRedux) => {
  const registryImageSrc = original || defaultImage;

  return (
    <>
      {isRegistryPhoto ? (
        <img css={styles.registryImageStyles} src={registryImageSrc} />
      ) : (
        <div css={[styles.container, imageSizeMap(configuration.imageSize)]}>
          <img css={styles.imageStyles} src={original} />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState, props: DisplayPhotoProps) => {
  if (props.section.image) {
    return {
      original: props.section.image,
    };
  }

  return {
    original: getPhotoByPk(state, props.section.photo)?.original || "",
  };
};

const ConnectedDisplayPhoto = connect(mapStateToProps)(
  DisplayPhoto,
) as unknown as React.FC<DisplayPhotoProps>;

const MemoizedDisplayPhoto = memo(ConnectedDisplayPhoto);

export { MemoizedDisplayPhoto as DisplayPhoto };
